// mobile-dialog.service.ts
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from './dialog.service';
import { IGroupedCard } from 'src/app/models/groupedCard';
import { ConfirmationDialogComponent } from '../components/dialog/confirmation-dialog.component';
import { POPUP_TEXT } from 'src/app/shared/text/popup-texts';
import { Observable } from 'rxjs';
import { UtilityFunctionsService } from './utility-functions.service';

@Injectable({
  providedIn: 'root'
})
export class MobileDialogService extends DialogService {
  constructor(private dialog: MatDialog, private utilityService: UtilityFunctionsService) {
    super();
  }

  openUploadErrorDialog(card: IGroupedCard): Observable<boolean> {
    const dialogConfig = {
      data: this.utilityService.applyPopupText(POPUP_TEXT.UPLOAD_ERROR_MOBILE, {
        '{modelTitle}': card.title,
        '{details}': card.details
      })
    };
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);

    return dialogRef.afterClosed();
  }

  openMissingTextureMappingDialog(card: IGroupedCard): Observable<boolean> {
    // For mobile, we'll show a simple confirmation dialog
    // In the future, this could be replaced with a mobile-specific texture mapping component
    const dialogConfig = {
      data: this.utilityService.applyPopupText(POPUP_TEXT.MISSING_TEXTURES, '{modelTitle}', card.title)
    };
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);

    return dialogRef.afterClosed();
  }
}
